import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { RouteInfo } from './vertical-sidebar.metadata';
import { VerticalSidebarService } from './vertical-sidebar.service';
import { Router, RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FeatherModule } from 'angular-feather';
import {AuthService} from "../../_services/auth.service";

@Component({
  selector: 'app-vertical-sidebar',
  standalone: true,
  imports:[TranslateModule, CommonModule, RouterModule, FeatherModule],
  templateUrl: './vertical-sidebar.component.html'
})
export class VerticalSidebarComponent implements OnInit {
  showMenu = '';
  showSubMenu = '';
  public sidebarnavItems: RouteInfo[] = [];
  path = '';


  @Input() showClass: boolean = false;
  @Output() notify: EventEmitter<boolean> = new EventEmitter<boolean>();


  handleNotify() {
    this.notify.emit(!this.showClass);
  }

  constructor(
    private menuService: VerticalSidebarService,
    private router: Router,
    private authService: AuthService,
  ) {
    this.menuService.items.subscribe(menuItems => {
      this.sidebarnavItems = menuItems;

      const currentUrl = this.router.url.split('?')[0];
      this.sidebarnavItems.forEach(m => {
        m.submenu.forEach(s => {
          if (s.path === currentUrl) {
            this.path = m.title;
          }
        });
      });

      if (this.path) {
        this.showMenu = this.path;
      }
    });
  }

  ngOnInit() {
    // Ensure menu items are refreshed when component initializes
    this.refreshMenuItems();
  }

  refreshMenuItems() {
    // Trigger a refresh of the menu items based on current user roles
    this.menuService.filterMenuItems();
  }

  addExpandClass(element: string) {
    if (element === this.showMenu) {
      this.showMenu = '0';
    } else {
      this.showMenu = element;
    }
  }

  addActiveClass(element: string) {
    if (element === this.showSubMenu) {
      this.showSubMenu = '0';
    } else {
      this.showSubMenu = element;
    }
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }

  logout(){
    this.authService.logout();
    // After logout, refresh menu items
    this.refreshMenuItems();
  }
  
  isDevUser(): boolean {
    return this.authService.hasRole('dev');
  }
  
  getCurrentUser() {
    return this.authService.getCurrentUser();
  }
}
